import { oc } from "@orpc/contract";
import * as z from "zod";
import { Id } from "./ids.js";

/** Cobble: which connected accounts a bot may use. Team bots use only the accounts ticked for them. */
export const BotConnectionSettingsSchema = z.object({
  teamBot: z.boolean(),
  limited: z.boolean(),
  canGrant: z.boolean(),
  canRevoke: z.boolean(),
  accounts: z.array(
    z.object({ id: z.string(), provider: z.string(), displayName: z.string(), allowed: z.boolean() }),
  ),
});
export type BotConnectionSettings = z.infer<typeof BotConnectionSettingsSchema>;

export const botConnectionsContract = {
  get: oc.input(z.object({ botId: Id })).output(BotConnectionSettingsSchema),
  set: oc
    .input(
      z.object({ botId: Id, limited: z.boolean(), connectionIds: z.array(z.string().min(1).max(64)).max(200) }),
    )
    .output(BotConnectionSettingsSchema),
};
